import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "../features/metrics/pages/dashboard-page";

/**
 * The panel's front door: how the platform is doing (US-14.4).
 *
 * <p>Recharts is imported from here down and nowhere else, so it lands in a route chunk rather than
 * in the entry one (verified in the build: ~394 kB beside a 278 kB entry). It is the heaviest thing
 * the panel depends on, and an operator who goes straight to the roasteries should not download a
 * chart nobody is drawing (CLAUDE.md §4).
 */
export const Route = createFileRoute("/")({
  component: DashboardPage,
});
